import gql from "graphql-tag"
import { basicMediaFragment } from "../../media/graphql/basicMediaFragment"
import { basicGuideFragment } from "./basicGuideFragment"
import { mediumRouteFragment } from "./mediumRouteFragment"
import { mediumProblemFragment } from "./mediumProblemFragment"
import { basicAreaFragment } from "./basicAreaFragment"
import { fullProblemFragment } from "./problems"
import { fullRouteFragment } from "./routes"
import { basicSendFragment } from "../../sends/graphql/basicSendFragment"

export const fullAreaFragment = gql`
  fragment fullAreaFragment on Area {
    _id
    name
    slug
    type
    hasMedia
    isNameEditable
    numProblems
    numRoutes
    numAreas
    location {
      coordinates
    }
    problemIds
    routeIds
    areaIds
    description
    directions
    access
    numWorkouts
    editors {
      user {
        _id
      }
    }
    version
    areas {
      ...basicAreaFragment
    }
    parentArea {
      ...basicAreaFragment
      parentArea {
        ...basicAreaFragment
      }
    }
    guide {
      ...basicGuideFragment
    }
    routes {
      ...mediumRouteFragment
    }
    problems {
      ...mediumProblemFragment
    }
    media {
      ...basicMediaFragment
    }
    popMedia {
      ...basicMediaFragment
    }
    sends {
      ...basicSendFragment
    }
  }
  ${basicAreaFragment}
  ${basicGuideFragment}
  ${mediumRouteFragment}
  ${mediumProblemFragment}
  ${basicMediaFragment}
  ${basicSendFragment}
`

export const AreaQuery = gql`
  query AreaQuery($slug: String!, $id: String) {
    area(slug: $slug, id: $id) {
      ...fullAreaFragment
    }
  }
  ${fullAreaFragment}
`

export const getAreasClosestToLocationQuery = gql`
  query getAreasClosestToLocation($point: PointInput!) {
    getAreasClosestToLocation(point: $point) {
      ...basicAreaFragment
      guide {
        ...basicGuideFragment
      }
    }
  }
  ${basicAreaFragment}
  ${basicGuideFragment}
`

export const GET_AREA_GRADE_DISTRIBUTION = gql`
  query GetAreaGradeDistribution($slug: String!) {
    area(slug: $slug) {
      _id
      problems {
        _id
        grade
      }
      routes {
        _id
        grade
      }
    }
  }
`

export const EDIT_AREA = gql`
  mutation EditArea($area: AreaInput!) {
    editArea(area: $area) {
      ...fullAreaFragment
    }
  }
  ${fullAreaFragment}
`
export const CREATE_AREA = gql`
  mutation CreateArea($area: AreaInput!) {
    createArea(area: $area) {
      ...fullAreaFragment
    }
  }
  ${fullAreaFragment}
`

export const DELETE_AREA = gql`
  mutation DeleteArea($areaId: String!) {
    deleteArea(areaId: $areaId) {
      ...fullAreaFragment
    }
  }
  ${fullAreaFragment}
`

export const addProblemToAreaMutate = gql`
  mutation addProblemToAreaMutate($problemId: String!, $areaId: String!) {
    addProblemToArea(problemId: $problemId, areaId: $areaId) {
      ...fullProblemFragment
    }
  }
  ${fullProblemFragment}
`

export const addRouteToAreaMutate = gql`
  mutation addRouteToAreaMutate($routeId: String!, $areaId: String!) {
    addRouteToArea(routeId: $routeId, areaId: $areaId) {
      ...fullRouteFragment
    }
  }
  ${fullRouteFragment}
`

export const addAreaToParentAreaMutate = gql`
  mutation addAreaToParentAreaMutate($areaId: String!, $parentAreaId: String!) {
    addAreaToParentArea(areaId: $areaId, parentAreaId: $parentAreaId) {
      ...fullAreaFragment
      parentArea {
        ...basicAreaFragment
      }
    }
  }
  ${fullAreaFragment}
  ${basicAreaFragment}
`

export const removeProblemFromAreaMutate = gql`
  mutation removeProblemFromAreaMutate($problemId: String!, $areaId: String!) {
    removeProblemFromArea(problemId: $problemId, areaId: $areaId) {
      ...fullProblemFragment
    }
  }
  ${fullProblemFragment}
`

export const removeRouteFromAreaMutate = gql`
  mutation removeRouteFromAreaMutate($routeId: String!, $areaId: String!) {
    removeRouteFromArea(routeId: $routeId, areaId: $areaId) {
      ...fullRouteFragment
    }
  }
  ${fullRouteFragment}
`

export const removeAreaFromParentAreasMutate = gql`
  mutation removeAreaFromParentAreasMutate($areaId: String!) {
    removeAreaFromParentAreas(areaId: $areaId) {
      ...fullAreaFragment
    }
  }
  ${fullAreaFragment}
`

export const CHECK_AREA_MEDIA = gql`
  mutation CheckAreaMedia($slug: String!) {
    checkAreaMedia(slug: $slug) {
      ...fullAreaFragment
    }
  }
  ${fullAreaFragment}
`

export default {
  fullAreaFragment,
  AreaQuery,
  EDIT_AREA,
  CREATE_AREA,
  DELETE_AREA,
  addProblemToAreaMutate,
  addRouteToAreaMutate,
  addAreaToParentAreaMutate,
  removeProblemFromAreaMutate,
  removeRouteFromAreaMutate,
  removeAreaFromParentAreasMutate,
}
